module.exports = __webpack_public_path__ + "static/media/uj_munkatars1.64336a2c.jpg";